module.exports = __webpack_public_path__ + "img/trailerRearRight.1efb3f46.svg";